module.exports = __webpack_public_path__ + "img/icon_5.597f5c3e.svg";